<template>
  <div v-if="loaded">
    <!-- AI聊天组件 -->
    <!--    <AIChat :packageNo="packageNo" @stopPlayHandel="stopPlayHandel"/>-->

    <!-- 顶部区域 -->
    <nav>
      <!-- 健康报告标题 -->
      <!-- <div class="report-title">检测报告</div> -->

      <!-- 报告编号和日期 -->
      <div class="file fx bt">
        <div>{{ $t('titles.reportNumber') }}：{{ packageNo }}</div>
        <div>{{ checkDate }}</div>
      </div>
      <div class="horizontal-line"></div>

      <!-- 包裹三个区域的容器，添加背景图 -->
      <div class="data-container">
        <!-- 用户信息 -->
        <UserInfoCard :user="user" v-if="user" />

        <!-- 数据指标 -->
        <div class="data fx" v-if="false">
          <!-- 生命体征 -->
          <div class="indicator-wrapper" @click="signDialog = true">
            <circle-progress :value="lifeFeaturePercent" :unit="$t('user.bodyFatUnit')" :label="$t('healthStatus.lifeFeature')" />
          </div>
          <div class="indicator-wrapper" @click="vigourDialog = true">
            <circle-progress :value="lifeFeaturePercent" :label="$t('healthStatus.bodyCondition')">
              <span style="color: #2976fe; font-size: 32px">{{
                lifeVigourLevel.text
              }}</span>
            </circle-progress>
          </div>
        </div>
        <!-- <div class="horizontal-line"></div> -->
        <!-- 基础数据 -->
        <!-- <div class="info">
          <ul>
            <li>
              <p>
                <b>身高<span class="unit">cm</span></b>
                <i>{{user.user_height}}</i>
              </p>
            </li>
            <li>
              <p>
                <b>体重<span class="unit">kg</span></b>
                <i>{{user.user_weight}}</i>
              </p>
            </li>
            <li>
              <p>
                <b>BMI<span class="unit"></span></b>
                <i class="bmi-value">{{user.user_bmi}}</i>
              </p>
            </li>
            <li>
              <p>
                <b>体脂率<span class="unit">%</span></b>
                <i class="fat-value">{{user.body_fat_ratio}}</i>
              </p>
            </li>
          </ul>

          <div class="fx">肥胖指数：{{user.body_fat_ratio_str || '参考区间'}}</div>
        </div> -->
      </div>
      <div class="horizontal-line" v-if="false"></div>
    </nav>
    <!-- 内容区域 -->
    <main>
      <AIInterpret ref="aIInterpretRef" :packageNo="packageNo" @suggestionHandle="suggestionHandle" :rand="rand"
        :checkcode="checkcode">
        <!-- <template>
          <div class="chat-button-container">
            <button class="ai-chat-button" @click="toggleChat">
              <span class="primary-text">和AI专家深入交流</span>
              <span class="secondary-text" v-if="isCollapsed"
          >需要一套量化干预方案? 跟我聊聊加分秘诀!</span
        >
            </button>
          </div>
        </template> -->
      </AIInterpret>
      <!-- 综合风险提示 -->
      <SectionView :title="$t('healthStatus.nutritionRisk')" v-if="false">
        <div class="overview-content">
          <ul>
            <!-- 将 li 替换为 div.risk-card 来应用卡片样式 -->
            <template v-if="overviews.length > 0">
              <li v-for="(item, index) in overviews" :key="index" data-type="1" class="risk-card">
                <router-link :to="{
                  path: '/details',
                  query: {
                    code: item.system_code,
                    title: item.item_dict_name,
                    av: item.av,
                    ...routeQuery,
                  },
                }" class="item-content">
                  <div class="content-wrapper">
                    <img class="item-icon" src="../assets/图标-红点@2x.png" :alt="$t('common.icon')" />
                    <span class="item-title">{{
                      item.comprehensive_evaluation
                    }}</span>
                  </div>
                  <!-- 直接显示箭头图标 -->

                  <img class="arrow-icon" src="../assets/图标-进入.png" :alt="$t('common.arrow')" />
                </router-link>
                <div class="item-description" v-if="item.introduction">
                  <span style="color: #495880">{{ item.introduction }}</span>
                </div>
                <div class="item-divider"></div>
              </li>
            </template>
            <!-- 将 li 替换为 div.risk-card 来应用卡片样式 -->
            <li v-else class="risk-card">
              <div class="item-content">
                <div class="content-wrapper">
                  <img class="item-icon" src="../assets/圆形图标.png" :alt="$t('common.icon')" />
                  <span class="item-title">{{ $t('healthStatus.noAbnormalRisk') }}</span>
                </div>
                <!-- 直接显示箭头图标 (虽然这里没有箭头，但保持结构一致性) -->
                <!-- <img class="arrow-icon" src="../assets/more.png" alt="箭头" /> -->
              </div>
            </li>
          </ul>
        </div>
      </SectionView>
      <div style="margin-top: -20px" v-if="false">
        <waterfall-card :data="sortedHealthData" :warningCount="warningHealthCount"
          :qualifiedCount="qualifiedHealthCount" :totalItems="healthData.length" :title="$t('healthStatus.healthRisk')"
          @item-click="handleHealthItemClick"></waterfall-card>
      </div>

      <NutritionVitalityCard :tabsData="nutritionTabs" @item-click="handleNutritionItemClick" />
      <div class="full-health-info-button-container full-health-info-button-stack">
        <router-link class="full-health-info-button full-health-info-button--primary" :to="{ path: '/overview', query: routeQuery }">{{ $t('actions.viewHealthInfo') }}
        </router-link>
        <div class="full-health-info-button-row" v-if="showPdfButton">
          <button
            v-if="showPdfButton"
            class="full-health-info-button full-health-info-button--pdf"
            @click="handleDownloadPDF"
          >
            {{ $t('actions.downloadPdfReport') }}
          </button>
        </div>
      </div>

      <div class="item-divider"></div>

      <!-- 饮食建议 -->
      <DietCard :useless="diets.useless" :useful="diets.useful" :suggestionData="suggestionData">
        <template v-slot:action>
          <button
            v-if="showCustomButton"
            class="full-health-info-button full-health-info-button--sub"
            @click="handleCustomSolution"
          >
            {{ $t('actions.customSolution') }}
          </button>
        </template>
      </DietCard>

      <div class="item-divider"></div>

      <!-- 检测要求和注意事项 -->
      <SectionView class="demand" :title="$t('requirements.title')">
        <p>
          {{ $t('requirements.item1') }}
        </p>
        <p>
          {{ $t('requirements.item2') }}
        </p>
        <p>
          {{ $t('requirements.item3') }}
        </p>
        <p>
          {{ $t('requirements.item4') }}
        </p>
      </SectionView>
    </main>

    <!-- 解读说明弹窗 -->
    <dialog-view v-model="interpret" class="interpret" :title="$t('dialogs.interpretTitle')">
      <span v-for="(item, index) in levels" :key="index"><i :style="{ background: item.color }"></i>{{ item.str
      }}</span>
    </dialog-view>

    <!-- 生命体征弹窗 -->
    <dialog-view :title="$t('dialogs.lifeFeatureTitle')" v-model="signDialog">
      {{ $t('dialogs.lifeFeatureDesc') }}
    </dialog-view>

    <!-- 生命活力弹窗 -->
    <dialog-view :title="$t('dialogs.bodyConditionTitle')" v-model="vigourDialog">
      {{ $t('dialogs.bodyConditionDesc') }}<br />
      <span style="font-weight: bold">{{ $t('healthStatus.healthy') }}</span>：{{ $t('dialogs.bodyConditionHealthyDesc') }}<br />
      <span style="font-weight: bold">{{ $t('healthStatus.good') }}</span>：{{ $t('dialogs.bodyConditionGoodDesc') }}<br />
      <span style="font-weight: bold">{{ $t('healthStatus.abnormal') }}</span>：{{ $t('dialogs.bodyConditionAbnormalDesc') }}
    </dialog-view>

    <!-- 新冠评估弹窗 -->
    <dialog-view :title="$t('dialogs.riskTitle')" v-model="xgDialog">
      {{ $t('dialogs.riskDesc') }}
    </dialog-view>

    <!-- 定制解决方案加载页面 -->
    <CustomSolutionLoader v-if="showSolutionLoader" @loading-complete="handleLoadingComplete" />
    
    <!-- 定制解决方案表单抽屉 -->
    <CustomSolutionDrawer :visible.sync="showDrawer" @submit="handleDrawerSubmit" @close="handleDrawerClose" />
  </div>
</template>

<script>
import { getReportInfoLoop, getSuggestion } from "@/net/api";
import { getReportLoopItemNutritionAll } from "@/net/api";
import { getReportLoopItem } from "@/net/api";
import SectionView from "@/components/SectionView";
import DietCard from "@/components/DietCard";
import DialogView from "../components/DialogView";
// import GaugeCard from "../components/GaugeCard";
import CircleProgress from "../components/CircleProgress";
import NutritionVitalityCard from "../components/NutritionVitalityCard";
import WaterfallCard from "../components/WaterfallCard";
import AIInterpret from "../components/AIInterpret";
import CustomSolutionLoader from "../components/CustomSolutionLoader";
import CustomSolutionDrawer from "../components/CustomSolutionDrawer";
import UserInfoCard from "../components/UserInfoCard";
// import AIChat from "../components/AIChat";
import aiChatMixin from "@/mixins/aiChatMixin";
import { isWechatEnvironment, navigateToMiniProgram } from "@/utils/wechat";
import { routeLanguageMixin } from "@/utils/routeLanguageHelper";

export default {
  name: "Home",
  mixins: [aiChatMixin, routeLanguageMixin],
  components: {
    SectionView,
    DietCard,
    DialogView,
    CircleProgress,
    NutritionVitalityCard,
    WaterfallCard,
    CustomSolutionLoader,
    CustomSolutionDrawer,
    UserInfoCard,
    // AIChat,
    AIInterpret
  },

  data() {
    return {
      // 报告编号
      packageNo: "",
      rand: "",
      checkcode: "",
      userHasInteracted: false,
      awaitingUserGesture: false,
      suggestionData: [],
      // 用户信息
      user: {
        name: "",
        age: "",
        gender: "1",
        birthday: "",
        body_fat_ratio: "0.00",
        body_fat_ratio_str: "",
        head_portrait: "",
        life_feature: "...",
        life_vigour: "...",
        life_vigour_percent: 100,
        report_mark_symbol: 0,
        user_bmi: "0.00",
        user_height: "0.00",
        user_weight: "0.00",
      },
      healthData: [],

      // 可能受影响的器官列表
      affectedOrgans: [],

      // 检测时间
      checkDate: "",

      // 新冠风险提示
      xg_data: null,
      // 综合风险
      overviews: [],
      // 不耐受食物
      diets: {
        useful: [],
        useless: [],
      },
      // 健康状态
      states: [],
      // 检测报告
      reports: [],
      // 报告等级列表
      levels: [],

      // 身体综合检测动态图
      dynamics: [],

      stackValueKey: {
        one: this.$t ? this.$t('charts.elements.initialValue') : '初值',
        two: this.$t ? this.$t('charts.elements.finalValue') : '终值',
      },
      avValueKey: {
        av: this.$t ? this.$t('charts.elements.averageValue') : '均值',
      },

      // 当前选中的健康状态
      state: 0,

      // 解读说明弹窗
      interpret: false,
      // 生命体征弹窗
      signDialog: false,
      // 生命活力弹窗
      vigourDialog: false,
      // 新冠评估弹窗
      xgDialog: false,

      // 当前数据是否加载完成
      loaded: false,

      // 营养素状态
      nutritionStatus: [],
      // 营养素列表 - 确保有一个默认值
      nutritionList: [
        {
          item_dict_name: "加载中...",
          system_code: "",
          av: "...",
        },
      ],
      nutritionTabs: [
        {
          name: this.$t ? this.$t('dataOverview.vitamins') : '维生素',
          warningCount: 0,
          qualifiedCount: 0,
          items: [],
        },
        // {
        //   name: "微量元素",
        //   warningCount: 0,
        //   qualifiedCount: 0,
        //   items: [],
        // },
        // {
        //   name: "矿物质",
        //   warningCount: 0,
        //   qualifiedCount: 0,
        //   items: [],
        // },
      ],
      // 列表关联项
      columns: {
        item_dict_name: this.$t ? this.$t('dataOverview.detectionItem') : '检测项目',
        av: this.$t ? this.$t('dataOverview.averageValue') + '(-4~+4)' : '均值(-4~+4)',
      },
      audioContext: null,
      audioQueue: null,
      // 先新增一个数组缓存 AudioBuffer，和一个累积长度限制（秒）
      audioBufferCache: [], // 缓存的 AudioBuffer 列表
      // audioBase64Queue = [],
      // isDecoding = false,
      cacheDurationLimit: 0.1, // 1秒为合并阈值，自己调节
      i: 0,

      // 定制解决方案相关
      showSolutionLoader: false, // 是否显示加载页面
      showDrawer: false, // 是否显示表单抽屉
      userFormData: null, // 用户填写的表单数据
      recommendData: null, // 推荐数据
      wxSDK: null, // 微信SDK实例

      // 页面来源判断
      isFromMiniProgram: false, // 是否来自小程序跳转
      hasPro: false, // URL是否包含pro参数
      hasSchemeAssess: false, // 是否开启方案评估跳转
      hasCustomSolution: false,

      // 第三方跳转标识
      isThirdParty: false,
    };
  },

  computed: {
    // 当前语言
    currentLanguage() {
      return this.$i18n.locale;
    },

    hideEntryActions() {
      return this.$store.getters.isThirdPartyMode;
    },
    
    // 是否显示一键定制按钮
    showCustomButton() {
      return !this.hideEntryActions && (this.hasSchemeAssess || this.hasCustomSolution);
    },

    showPdfButton() {
      return !this.hideEntryActions && this.hasPro;
    },
    
    stateImage() {
      return this.states.length > 0
        ? this.states[this.state].image_url_big
        : null;
    },
    // 生命营养状态
    healthDataFromStates() {
      if (!this.states || this.states.length === 0) {
        return [];
      }

      return this.states.map((item) => ({
        name: this.normalizeComplianceText(item.item_dict_name || ""),
        value: parseFloat(item.av) || 0,
      }));
    },
    sortedHealthData() {
      // 复制数组以避免修改原始数据
      return [...this.healthData];
    },

    // 计算警告数量（小于0的项目）
    warningHealthCount() {
      return this.healthData.filter((item) => item.value < 0).length;
    },

    // 计算合格数量（大于等于0的项目）
    qualifiedHealthCount() {
      return this.healthData.filter((item) => item.value >= 0).length;
    },

    // 生命体征百分比转换
    lifeFeaturePercent() {
      // 如果user对象不存在或还未加载数据或者值不是数字，返回0
      if (
        !this.user ||
        this.user.life_feature === "..." ||
        isNaN(Number(this.user.life_feature))
      ) {
        return 0;
      }

      // 将 -4 到 +4 的范围转换为 0-100 的百分比
      const value = Number(this.user.life_feature);
      const percent = Math.round(((value + 4.5) / 8) * 100);
      // 确保百分比在 0-100 范围内
      return Math.max(0, Math.min(100, percent));
    },

    // 生命活力等级判断
    lifeVigourLevel() {
      // 直接使用lifeFeaturePercent计算结果
      const percent = this.lifeFeaturePercent;

      // 根据百分比划分三个等级，但统一使用相同的颜色类名
      if (percent >= 70) {
        return { text: this.$t('healthStatus.healthy'), color: "health" };
      } else if (percent >= 40) {
        return { text: this.$t('healthStatus.good'), color: "health" };
      } else {
        return { text: this.$t('healthStatus.good'), color: "health" };
      }
    },

    // 生命活力等级对应的颜色
    vigourLevelColor() {
      switch (this.lifeVigourLevel.color) {
        case "health":
          return ["#2ECC71", "#27ae60"];
        case "good":
          return ["#FFFFB5", "#D4B400"];
        case "abnormal":
          return ["#E74C3C", "#c0392b"];
        default:
          return ["#FFFFB5", "#D4B400"];
      }
    },

    // 基础参数数据
    query() {
      const baseQuery = {
        packageNo: this.packageNo,
        rand: this.rand,
        checkcode: this.checkcode,
      };

      const currentQuery = this.$route.query || {};
      if (currentQuery.schemeAssess !== undefined) {
        baseQuery.schemeAssess = currentQuery.schemeAssess;
      }
      if (currentQuery.customSolution !== undefined) {
        baseQuery.customSolution = currentQuery.customSolution;
      }

      return baseQuery;
    },

    // 用户基础信息
    basicLabel() {
      const { age } = this.user;
      return age ? age + this.$t('user.age') : "";
    },

    // 动态计算文字长度
    smallUserName() {
      const maxWidth = window.innerWidth * 0.86;
      let canvas = document.createElement("canvas");
      let ctx = canvas.getContext("2d");
      ctx.font =
        "normal bold " +
        40 / (750 / window.innerWidth) +
        "px PingFangSC-Semibold, PingFang SC ";
      let width = ctx.measureText(this.user.name).width;
      return width > maxWidth ? "small" : "";
    },
  },

  // GaugeCard  ,添加圆环时候 要加上计算长度

  created() {
    // 更新营养素列表的默认值为国际化文本
    this.nutritionList[0].item_dict_name = this.$t('common.loading');

    // 优先从URL查询参数获取
    const query = this.$router.currentRoute.query;
    this.packageNo = query.packageNo;
    this.checkcode = query.checkcode;
    this.rand = query.rand;

    // 判断是否来自小程序跳转（保留用于其他逻辑）
    this.isFromMiniProgram = this.checkIfFromMiniProgram(query);
    // 检查URL是否包含pro=1参数
    this.hasPro = query.pro === '1';
    this.hasSchemeAssess = query.schemeAssess === '1';
    this.hasCustomSolution = query.customSolution === '1';

    // 从URL参数读取第三方跳转标识
    this.isThirdParty = query.isThirdParty === '1';

    console.log("页面来源判断:", {
      isFromMiniProgram: this.isFromMiniProgram,
      source: query.source,
      hasPro: this.hasPro,
      hasSchemeAssess: this.hasSchemeAssess,
      isThirdParty: this.isThirdParty,
      showCustomButton: this.showCustomButton,
      query: query
    });

    // 重置 AI 状态（新报告开始时）
    this.resetAIState();
    this.$store.commit("SetPackageNo", {
      packageNo: query.packageNo,
    });

    // 设置初始加载状态
    this.keyResultsLoading = true;

    console.log("报告参数:", {
      packageNo: this.packageNo,
      checkcode: this.checkcode,
      rand: this.rand,
    });

    // 加载页面数据
    this.syncPageData();
  },

  mounted() {
    // 检查是否支持Web Audio API
    // if (window.AudioContext || window.webkitAudioContext) {
    //   // 初始化音频上下文，提前准备好音频环境
    //   this.initAudioContext();
    //   // 确保页面加载后自动播放音频 (设置标志位为true)
    //   this.soundOn = true;
    // } else {
    //   console.warn("当前浏览器不支持Web Audio API，音频功能将不可用");
    //   this.soundOn = false;
    // }

    // 监听页面可见性变化，当页面隐藏时清理加载状态
    document.addEventListener('visibilitychange', this.handleVisibilityChange);
  },

  beforeDestroy() {
    // 清理事件监听器
    document.removeEventListener('visibilitychange', this.handleVisibilityChange);
  },

  methods: {
    // 打开语音小助手，关闭音频
    stopPlayHandel() {
      console.log('home9999')
      this.$refs.aIInterpretRef.stopPlay()
    },
    // 同步页面数据
    syncPageData() {
      // 获取报告数据
      getReportInfoLoop({
        packageNo: this.packageNo,
        rand: this.rand,
        checkcode: this.checkcode,
      })
        .then((data) => {
          this.levels = data.colorData;
          // 安全地设置用户数据，如果userData为空则保持原有数据
          if (data.userData) {
            this.user = data.userData;
          } else {
            console.warn('userData为空，保持原有用户数据');
          }
          this.checkDate = data.checkDate;
          this.overviews = (data.comprehensiveRisk || []).map((item) => ({
            ...item,
            item_dict_name: this.normalizeComplianceText(item.item_dict_name),
            comprehensive_evaluation: this.normalizeComplianceText(item.comprehensive_evaluation)
          }));
          this.fetchOverviewsIntroduction();
          this.states = data.show_jiankangzhaungtaitu;
          this.reports = data.show_jiancebaogao;
          this.dynamics = data.show_shentizonghejiancedongtaitu;
          this.xg_data = data.xg_data;
          // 从 states 数据中提取健康数据
          if (this.states && this.states.length > 0) {
            this.healthData = this.states.map((item) => ({
              code: item.system_code || "",
              name: this.normalizeComplianceText(item.item_dict_name || ""),
              value: parseFloat(item.av) || 0,
            }));
            // 不再调用updateAffectedOrgans方法
          }

          // 始终调用fetchNutritionData来获取营养素数据，而不依赖getReportInfoLoop返回的数据
          this.fetchNutritionData();

          // 在基础数据加载后获取AI解读
          // this.fetchAIInterpretData();
        })
        .catch((err) => {
          console.error("获取报告数据出错:", err);
          this.loaded = true;
          // 即使发生错误，也尝试获取AI解读
          // this.fetchAIInterpretData();
        });
    },

    // 处理健康指标项点击
    handleHealthItemClick(item) {
      console.log("健康指标点击:", item);
      // 查找对应的原始数据项，获取system_code

      this.navigateWithLanguage({
        path: "/details",
        query: {
          code: item.code || "",
          title: item.name,
          av: item.value || "",
          ...this.query,
        },
      });
    },
    handleNutritionItemClick(item) {
      this.navigateWithLanguage({
        path: "/nutrition",
        query: {
          code: item.code || "",
          title: item.name,
          av: item.av || "",
          ...this.query,
        },
      });
    },

    // 获取营养素数据
    fetchNutritionData() {
      getReportLoopItemNutritionAll({
        packageNo: this.packageNo,
        rand: this.rand,
        checkcode: this.checkcode,
      })
        .then((data) => {
          console.log("营养素数据:", data);
          this.nutritionStatus = data.show_zhuangtaitu || [];
          this.nutritionList = data.show_xiangxishuju || [];
          this.processNutritionData();

          // 获取营养素数据后更新受影响的器官
          // this.updateAffectedOrgans();

          console.log(this.nutritionList);

          this.loaded = true;
        })
        .catch((err) => {
          console.error("获取营养素数据出错:", err);
          this.loaded = true;
        });
    },

    processNutritionData() {
      if (!this.nutritionList || this.nutritionList.length === 0) return;

      // 假设前10个是维生素，接下来8个是微量元素，剩余的是矿物质
      // const vitamins = this.nutritionList.slice(0, 10);
      // const microelements = this.nutritionList.slice(10, 17);
      // const minerals = this.nutritionList.slice(17, 26);

      // 转换数据格式
      const convertToTabFormat = (items) => {
        return items.map((item) => {
          // 假设item.av是一个-4到+4的值
          const value = parseFloat(item.av) || 0;
          return {
            name: this.normalizeComplianceText(item.item_dict_name),
            value: value,
            nameEn: item.item_dict_name_en,
            code: item.system_code,
            av: item.av,
          };
        });
      };

      // 计算预警和合格项目数量
      const countWarningAndQualified = (items) => {
        let warningCount = 0;
        let qualifiedCount = 0;

        items.forEach((item) => {
          const value = parseFloat(item.av) || 0;
          if (value < 0) {
            warningCount++;
          } else {
            // 其他为合格项目
            qualifiedCount++;
          }
        });

        return { warningCount, qualifiedCount };
      };

      // 更新维生素标签页
      console.log(this.nutritionList);
      const stats = countWarningAndQualified(this.nutritionList);
      this.nutritionTabs[0].items = convertToTabFormat(this.nutritionList);
      this.nutritionTabs[0].warningCount = stats.warningCount;
      this.nutritionTabs[0].qualifiedCount = stats.qualifiedCount;

      // 更新维生素标签页
      // const vitaminStats = countWarningAndQualified(vitamins);
      // this.nutritionTabs[0].items = convertToTabFormat(vitamins)
      // this.nutritionTabs[0].warningCount = vitaminStats.warningCount;
      // this.nutritionTabs[0].qualifiedCount = vitaminStats.qualifiedCount;

      // 更新微量元素标签页
      // const microStats = countWarningAndQualified(microelements);
      // this.nutritionTabs[2].items = convertToTabFormat(microelements);
      // this.nutritionTabs[2].warningCount = microStats.warningCount;
      // this.nutritionTabs[2].qualifiedCount = microStats.qualifiedCount;
      //
      // // 更新矿物质标签页
      // const mineralStats = countWarningAndQualified(minerals);
      // this.nutritionTabs[1].items = convertToTabFormat(minerals);
      // this.nutritionTabs[1].warningCount = mineralStats.warningCount;
      // this.nutritionTabs[1].qualifiedCount = mineralStats.qualifiedCount;

      console.log("处理后的营养标签页数据:", this.nutritionTabs);
    },

    // 获取每个健康指标的详细介绍
    fetchOverviewsIntroduction() {
      if (!this.overviews || this.overviews.length === 0) return;

      // 为每个健康指标获取介绍信息
      this.overviews.forEach((item, index) => {
        getReportLoopItem({
          packageNo: this.packageNo,
          rand: this.rand,
          checkcode: this.checkcode,
          system_code: item.system_code,
        }).then((data) => {
          // 使用Vue的$set方法确保响应式更新
          this.$set(
            this.overviews[index],
            "introduction",
            data.show_liuduan !== this.$t('healthStatus.noAbnormalRiskFound') ? this.normalizeComplianceText(data.show_liuduan) : ""
          );
          this.diets.useful = data.show_yinshijianyi.tolerantFood || [];
          // 隐藏不推荐的食材
          // this.diets.useless = data.show_yinshijianyi.noTolerantFood || [];
        });
      });
    },

    // 导航到概览页面
    navigateToOverview(code) {
      if (!code) {
        console.error("导航错误：缺少code参数");
        return;
      }

      this.navigateWithLanguage({
        path: "/overview",
        query: {
          code: code,
          ...this.query,
        },
      });
    },
    // 调用AIChat组件的打开聊天功能
    // toggleChat() {
    //   // 查找AIChat组件实例
    //   const aiChatComponent = this.$children.find(
    //     (child) => child.$options.name === "AIChat"
    //   );
    //   if (aiChatComponent) {
    //     aiChatComponent.toggleChat();
    //   }
    // },
    // 获取解读建议
    async suggestionHandle() {
      const res = await getSuggestion({ serial_number: this.packageNo })
      if (res) {
        this.suggestionData = res
      }
    },

    // 处理一键定制解决方案按钮点击
    async handleCustomSolution() {
      console.log('[H5] 点击一键定制解决方案按钮');
      console.log('[H5] 当前isThirdParty值:', this.isThirdParty);
      console.log('[H5] 当前URL参数:', this.$router.currentRoute.query);

      // 检查是否为第三方跳转
      if (this.isThirdParty) {
        console.log('[H5] 检测到第三方跳转，执行返回逻辑');
        this.handleThirdPartyReturn();
        return;
      }

      if (this.hasSchemeAssess) {
        await this.navigateToSchemeAssessBridge();
        return;
      }

      console.log('[H5] 非第三方跳转，显示抽屉');
      // 原有逻辑：显示底部抽屉
      this.showDrawer = true;
    },

    navigateToSchemeAssessBridge() {
      if (!this.packageNo) {
        this.showErrorMessage('缺少报告编号，请刷新后重试');
        return Promise.reject(new Error('缺少报告编号'));
      }

      if (typeof wx === 'undefined' || !wx.miniProgram) {
        this.showErrorMessage('请在小程序中打开此页面');
        return Promise.reject(new Error('不在小程序环境'));
      }

      const targetUrl = `/pages/shop/schemeAssessBridge/schemeAssessBridge?packageNo=${encodeURIComponent(this.packageNo)}`;
      console.log('[H5] 跳转方案评估中转页:', targetUrl);

      return new Promise((resolve, reject) => {
        wx.miniProgram.navigateTo({
          url: targetUrl,
          success: resolve,
          fail: (err) => {
            console.error('[H5] 跳转方案评估中转页失败:', err);
            this.showErrorMessage('跳转失败，请稍后重试');
            reject(err);
          }
        });
      });
    },

    // 下载PDF报告 - Flutter App或小程序页面
    async handleDownloadPDF() {
      if (this.isFlutterApp()) {
        await this.navigateToFlutterPdfDownload();
        return;
      }

      // eslint-disable-next-line no-undef
      if (typeof wx !== 'undefined' && wx.miniProgram) {
        // eslint-disable-next-line no-undef
        wx.miniProgram.navigateTo({
          url: '/pages/report/pdfDownload/pdfDownload?packageNo=' + (this.packageNo || '')
        });
      } else {
        alert(this.$t('home.messages.openInMiniProgram'));
      }
    },

    /**
     * 处理第三方返回
     */
    handleThirdPartyReturn() {
      console.log('[H5] 用户点击返回按钮');

      // 严格的环境检测
      // eslint-disable-next-line no-undef
      if (typeof wx === 'undefined') {
        console.error('[H5] wx对象不存在');
        alert(this.$t('home.messages.notInWechat'));
        return;
      }

      // eslint-disable-next-line no-undef
      if (!wx.miniProgram) {
        console.error('[H5] wx.miniProgram不存在');
        alert(this.$t('home.messages.notInMiniProgram'));
        return;
      }

      // 检查环境变量
      const env = window.__wxjs_environment;
      if (env !== 'miniprogram') {
        console.error('[H5] 环境检测失败，env:', env);
        alert(this.$t('home.messages.notInMiniProgramWebview'));
        return;
      }

      console.log('[H5] 环境检测通过，开始返回流程');

      // 准备报告数据
      const reportData = {
        status: 'success',
        reportId: this.packageNo || '',
        reportUrl: window.location.href,
        checkTime: this.checkDate || '',
        customerName: this.user.name || ''
      };

      console.log('[H5] 发送返回消息:', reportData);

      try {
        // 通过postMessage发送消息给小程序
        // eslint-disable-next-line no-undef
        wx.miniProgram.postMessage({
          data: {
            action: 'thirdPartyReturn',
            data: reportData
          }
        });

        console.log('[H5] postMessage发送成功');

        // 提示用户
        alert(this.$t('home.messages.returnSoon'));

        // 延迟后返回小程序（触发bindmessage）
        setTimeout(() => {
          console.log('[H5] 开始执行navigateBack');
          // eslint-disable-next-line no-undef
          wx.miniProgram.navigateBack({
            success: () => {
              console.log('[H5] navigateBack成功');
            },
            fail: (err) => {
              console.error('[H5] navigateBack失败:', err);
              alert(this.$t('home.messages.returnFailed', { message: err.errMsg }));
            }
          });
        }, 500);
      } catch (err) {
        console.error('[H5] 返回过程异常:', err);
        alert(this.$t('home.messages.returnFailed', { message: err.message }));
      }
    },

    // 检测是否在Flutter App环境中
    isFlutterApp() {
      return window.flutter_inappwebview && typeof window.flutter_inappwebview.callHandler === 'function';
    },
    
    // 处理抽屉表单提交
    async handleDrawerSubmit(formData) {
      console.log('表单提交:', formData);
      console.log('收集到的问卷keys:', formData.selectedKeys);
      this.userFormData = formData;
      
      // 关闭抽屉
      this.showDrawer = false;
      
      try {
        // 显示加载页面
        this.showSolutionLoader = true;
        
        // 判断环境并执行对应的跳转逻辑
        if (this.isFlutterApp()) {
          // Flutter App环境
          await this.navigateToFlutterApp(formData.selectedKeys);
        } else {
          // 微信环境或其他H5环境
          // 这里保持原有逻辑，等待加载完成后跳转
        }
        
      } catch (error) {
        console.error('提交失败:', error);
        this.showSolutionLoader = false;
        this.showErrorMessage('提交失败，请稍后重试');
      }
    },
    
    // 处理抽屉关闭
    handleDrawerClose() {
      console.log('抽屉关闭');
    },

    // 获取推荐数据（已禁用）
    async fetchRecommendData() {
      // 此方法已禁用，不再调用接口
      console.log('fetchRecommendData方法已禁用');
      return null;
    },

    // 加载完成后的处理
    async handleLoadingComplete() {
      console.log('加载完成，准备跳转');

      try {
        // 如果是Flutter App环境，不需要在这里处理（已在表单提交时处理）
        if (this.isFlutterApp()) {
          this.showSolutionLoader = false;
          return;
        }
        
        // 检测微信环境
        if (!this.isWechatEnvironment()) {
          this.showSolutionLoader = false;
          this.showErrorMessage('请在微信中打开此页面');
          return;
        }

        // 跳转到小程序
        await this.navigateToMiniProgram();

      } catch (error) {
        console.error('跳转失败:', error);
        this.showSolutionLoader = false;
        this.showErrorMessage('跳转失败，请稍后重试');
      }
    },

    // 检测微信环境（使用工具类）
    isWechatEnvironment() {
      return isWechatEnvironment();
    },

    // 跳转到Flutter App页面
    async navigateToFlutterApp(questionnaireKeys) {
      try {
        console.log('准备跳转到Flutter App，问卷keys:', questionnaireKeys);
        
        const result = await window.flutter_inappwebview.callHandler('navigateToEvaluationPlan', {
          packageNo: this.packageNo,
          questionnaire: questionnaireKeys || []
        });
        
        console.log('Flutter App导航成功:', result);
        this.showSolutionLoader = false;
        
      } catch (error) {
        console.error('Flutter App导航失败:', error);
        this.showSolutionLoader = false;
        this.showErrorMessage('跳转失败，请稍后重试');
        throw error;
      }
    },

    // 跳转到Flutter App PDF下载页
    async navigateToFlutterPdfDownload() {
      try {
        console.log('准备跳转到Flutter PDF下载页，packageNo:', this.packageNo);

        const result = await window.flutter_inappwebview.callHandler('navigateToPdfDownload', {
          packageNo: this.packageNo || ''
        });

        console.log('Flutter PDF下载页导航成功:', result);
      } catch (error) {
        console.error('Flutter PDF下载页导航失败:', error);
        this.showErrorMessage('跳转失败，请稍后重试');
        throw error;
      }
    },
    
    // 跳转到小程序页面
    async navigateToMiniProgram() {
      try {
        // 收集用户选择的问卷keys
        const selectedKeys = this.userFormData?.selectedKeys || [];
        
        // 将keys数组转为JSON字符串并编码
        const questionnaireParam = encodeURIComponent(JSON.stringify(selectedKeys));
        
        console.log('收集到的问卷keys:', selectedKeys);
        console.log('编码后的参数:', questionnaireParam);
        
        // 准备传递给小程序的数据（包含用户填写的表单信息）
        const miniProgramData = {
          serial_number: this.packageNo,
          timestamp: Date.now(),
          source: 'h5_custom_solution',
          userInfo: this.userFormData // 传递用户填写的信息
        };

        console.log('准备跳转到小程序，数据:', miniProgramData);

        // 使用工具类进行跳转，将questionnaire参数添加到URL中
        const jumpPromise = navigateToMiniProgram({
          appId: 'wx8c05eb024a5db14a', // 小程序AppID
          path: `/pages/shop/evaluationPlan/evaluationPlan?packageNo=${this.packageNo}&questionnaire=${questionnaireParam}&pro=1`,
          extraData: miniProgramData,
          envVersion: 'release' // 正式版
        });

        // 延迟一小段时间后开始跳转，确保加载动画完整显示
        setTimeout(() => {
          console.log('开始执行小程序跳转');
        }, 500);

        await jumpPromise;
        console.log('小程序页面跳转成功');

        // 跳转成功后，页面会被小程序接管，加载状态会通过页面可见性监听自动清理

      } catch (error) {
        console.error('跳转过程中出错:', error);
        throw error;
      }
    },



    // 显示错误消息
    showErrorMessage(message) {
      // 这里可以使用Toast组件或者alert
      if (this.$toast) {
        this.$toast(message);
      } else {
        alert(message);
      }
    },

    // 处理页面可见性变化
    handleVisibilityChange() {
      // 当页面变为隐藏状态时，清理加载页面状态
      if (document.hidden && this.showSolutionLoader) {
        console.log('页面隐藏，清理加载状态');
        // 延迟清理，确保跳转完成
        setTimeout(() => {
          this.showSolutionLoader = false;
        }, 1000);
      }
    },



    // 判断是否来自小程序跳转
    checkIfFromMiniProgram(query) {
      // 方法1: 检查URL参数中的from标识
      if (query.from === 'miniprogram') {
        console.log('通过URL参数判断：来自小程序');
        return true;
      }

      // 方法2: 检查微信环境和User Agent
      const ua = navigator.userAgent.toLowerCase();
      const isWechat = ua.includes('micromessenger');
      const isMiniProgram = window.__wxjs_environment === 'miniprogram' || ua.includes('miniprogram');

      if (isWechat && isMiniProgram) {
        console.log('通过环境检测判断：来自小程序');
        return true;
      }

      // 方法3: 检查Referer（如果有的话）
      const referer = document.referrer;
      if (referer && referer.includes('servicewechat.com')) {
        console.log('通过Referer判断：来自小程序');
        return true;
      }

      // 方法4: 检查特定的参数组合（小程序跳转时通常会带这些参数）
      const hasRequiredParams = query.packageNo && query.checkcode && query.rand;
      if (hasRequiredParams && isWechat) {
        console.log('通过参数组合和微信环境判断：可能来自小程序');
        return true;
      }

      console.log('判断结果：不是来自小程序');
      return false;
    },
    normalizeComplianceText(text) {
      if (!text) {
        return "";
      }
      return String(text)
        .replace(/未见异常风险/g, "暂无重点关注项")
        .replace(/异常/g, "偏低关注")
        .replace(/正常/g, "参考区间")
        .replace(/优异/g, "偏高关注")
        .replace(/严重缺乏/g, "建议关注项")
        .replace(/功能不足/g, "相关状态建议关注")
        .replace(/供血压力增大/g, "建议结合饮食、作息、运动综合管理")
        .replace(/心脑供血压力增大/g, "建议结合饮食、作息、运动综合管理")
        .replace(/供血不足/g, "建议结合饮食、作息、运动综合管理")
        .replace(/脾功能不足/g, "脾胃相关状态建议关注");
    }

  },
};
</script>

<style lang="scss" scoped>
/* 顶部 */
nav {
  // position: relative;
  //height: 700px;
  /* 使用背景图片实现渐变效果 */
  // background-image: url("../assets/bg.png");
  // background-repeat: no-repeat;
  // background-size: 100% 100%;
  padding: 30px;
  color: #0f0707;
  box-sizing: border-box;

  /* 健康报告标题 */
  .report-title {
    font-size: 44px;
    font-weight: 600;
    text-align: center;
    margin-top: 62px;
    margin-bottom: 9px;
    letter-spacing: 2px;
  }

  /* 报告编号和日期 */
  .file {
    font-size: 24px;
    padding-left: 8rpx;
    padding-right: 8rpx;
    color: rgba(47, 41, 41, 0.7);

    div {
      height: 36px;
    }
  }

  .horizontal-line {
    margin-bottom: 40px;
    border-bottom: 1px solid #cccccc;
    width: 100%;
  }

  /* 包裹三个区域的容器，添加背景图 */
  .data-container {
    position: relative;
    padding: 10px 15px;
    margin: 0 -15px;
    margin-top: -30px;
    margin-bottom: 25px;
    // background-image: url("../assets/bg-01.png");
    // background-repeat: no-repeat;
    // background-size: 100% 100%;

    /* 用户信息 */
    .user {
      height: 120px;
      display: flex;
      justify-content: center;
      align-items: center;

      .user-row {
        display: flex;
        align-items: center;
        height: 65px;
        background-color: #eaf3ff;
        border-radius: 80px;
        padding: 0 50px;
      }

      .user-name-container {
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .user-name {
        font-size: 30px;
        font-weight: 500;
        color: #1a1a1a;
      }

      .gender-icon {
        width: 33px;
        height: 33px;
        margin-left: 10px;
      }

      .divider {
        width: 1px;
        height: 27px;
        background-color: #b5c7f7;
        margin: 0 30px;
      }

      .user-age {
        font-size: 26px;
        font-weight: 400;
        color: #131111;
      }

      b,
      span {
        display: none;
      }
    }

    /* 数据指标 */
    .data {
      display: flex;
      justify-content: center;
      padding-top: 10px;
      margin-bottom: 20px;
      box-shadow: none;

      .indicator-wrapper {
        position: relative;
        width: 280px;
        height: 280px;
        display: flex;
        justify-content: center;
        align-items: center;
        background: transparent;
        box-shadow: none;

        &:last-child {
          margin-left: 70px;
        }
      }
    }

    /* 基础数据 */
    // .info {
    //   display: flex;
    //   height: 230px;
    //   overflow: hidden;
    //   flex-direction: column;
    //   margin-top: 24px;
    //   color: #000000;

    //   ul {
    //     flex: 1;
    //     padding: 0 12px;

    //     li {
    //       position: relative;
    //       flex: 1;
    //       display: flex;
    //       align-items: center;
    //       justify-content: center;
    //       font-size: 28px;
    //       color: #000000;

    //       &:after {
    //         position: absolute;
    //         content: "";
    //         display: block;
    //         width: 1px;
    //         height: 40px;
    //         background: #C7C7C7;
    //         border-radius: 1px;
    //         right: 0;
    //       }

    //       &:last-child {
    //         &:after {
    //           display: none;
    //         }
    //       }

    //       p {
    //         display: flex;
    //         flex-direction: column;
    //         align-items: flex-start;
    //       }

    //       b {
    //         font-weight: 400;
    //         font-size: 26px;
    //         color: #000000;

    //         .unit {
    //           font-size: 25px;
    //           margin-left: 4px;
    //           font-weight: normal;
    //           color: #999999;
    //         }
    //       }

    //       i {
    //         padding-top: 10px;
    //         color: #333333;
    //         font-weight: 500;
    //         font-family: AccidentalPresidency;
    //         font-size: 38px;

    //         &.bmi-value {
    //           color: #FF5C4D;
    //         }

    //         &.fat-value {
    //           color: #FD9243;
    //         }
    //       }
    //     }
    //   }

    //   div {
    //     font-size: 26px;
    //     height: 100px;
    //     color: #000000;
    //   }
    // }
  }
}

/* 内容 */
main {
  margin-top: -60px;
  padding: 10px 15px;

  .link {
    display: block;
    text-decoration: none;
    height: 80px;
    border-radius: 20px;
    font-size: 32px;
    color: #6ca0ec;
    line-height: 80px;
    padding: 0 30px;
    background-color: #edf4ff;
    background-image: url("../assets/more.png");
    background-repeat: no-repeat;
    background-position: right 30px center;
    background-size: 40px 40px;
  }

  .overview {
    background-color: #ffffff;
    min-height: 256px;
    padding: 15px 0;
    margin: 10px 0;

    ul {
      flex-direction: column;
      align-items: flex-start;
      padding-left: 20px;
      padding-top: 15px;
      padding-right: 20px;

      li {
        position: relative;
        margin-bottom: 12px;
        display: flex;
        flex-direction: column;
        width: 100%;
        border-bottom: 1px solid #eaeaea;
        padding-bottom: 8px;
      }

      /* 移除 item-number 样式 */
      /* .item-number { ... } */

      /* 添加 item-icon 样式 */
      .item-icon {
        width: 36px;
        /* 根据需要调整大小 */
        height: 36px;
        /* 根据需要调整大小 */
        margin-right: 12px;
        /* 调整与标题的间距 */
        flex-shrink: 0;
        vertical-align: middle;
        /* 尝试垂直居中 */
      }

      .item-content {
        position: relative;
        z-index: 1;
        text-decoration: none;
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        width: 100%;
        padding-top: 8px;
        min-height: 40px;
        padding-bottom: 0px;
      }

      .content-wrapper {
        display: flex;
        align-items: center;
        /* 让图标和文字垂直居中 */
        flex: 1;
      }

      .item-title {
        flex: 1;
        font-size: 30px;
        font-weight: 900;
        line-height: 1.3;
      }

      .item-description {
        font-size: 24px;
        color: #495880;
        line-height: 1.5;
        margin-top: 8px;
        margin-left: 0;
        padding-left: 0;
        margin-right: 0;
        text-align: justify;
        padding-bottom: 10px;
        padding-top: 0;
        width: 100%;
        box-sizing: border-box;
      }

      .arrow-icon {
        width: 40px;
        height: 40px;
        margin-left: auto;
        margin-right: 8px;
        margin-top: 2px;
        object-fit: contain;
        filter: drop-shadow(0 0 1px rgba(0, 0, 0, 0.1));
        flex-shrink: 0;
      }
    }
  }

  .overview-content {
    min-height: auto;
    /* 重置最小高度 */

    ul {
      flex-direction: column;
      align-items: stretch;
      /* 让列表项撑满宽度 */
      padding: 0 3px;
      /* 调整左右内边距 */

      /* 应用卡片样式 */
      .risk-card {
        position: relative;
        display: flex;
        /* 使用 flex 布局 */
        flex-direction: column;
        width: 100%;
        // background-color: #F8FCFF;
        border-radius: 20px;
        /* 圆角 */
        padding-bottom: 10px;
        padding-right: 20px;
        // box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05); /* 调整阴影 */
        box-sizing: border-box;
        /* 确保 padding 不会撑大元素 */
      }

      /* 调整图标样式 - 匹配目标图片 */
      .item-icon {
        width: 40px;
        height: 40px;
        margin-right: 10px;
        flex-shrink: 0;
        vertical-align: middle;
      }

      .item-content {
        position: relative;
        color: #333333;
        z-index: 1;
        text-decoration: none;
        display: flex;
        justify-content: space-between;
        align-items: center;
        /* 垂直居中对齐 */
        width: 100%;
      }

      .content-wrapper {
        display: flex;
        align-items: center;
        flex: 1;
        margin-right: 10px;
      }

      .item-title {
        flex: 1;
        font-size: 28px;
        font-weight: 600;
        line-height: 1.3;
        color: #333;
      }

      .item-description {
        font-size: 24px;
        color: #666666;
        line-height: 1.4;
        margin-top: 20px;
        padding-left: 42px;
        text-align: justify;
        width: 100%;
        box-sizing: border-box;
      }

      /* 调整箭头图标样式 - 匹配目标图片 */
      .arrow-icon {
        width: 40px;
        /* 增大箭头图标大小 */
        height: 40px;
        /* 增大箭头图标大小 */
        flex-shrink: 0;
        /* 防止被压缩 */
      }
    }
  }

  /* 健康状态图 */
  .state {
    .preview {
      position: absolute;
      width: 100%;
      top: 50px;
      bottom: 0;

      img {
        max-height: 616px;
      }
    }

    ul {
      position: relative;
      height: 626px;
      flex-direction: column;
      flex-wrap: wrap;
      justify-content: flex-start;
      align-content: space-between;
      z-index: 1;

      li {
        width: 170px;
        height: 60px;
        border-radius: 10px;
        border: 1px solid #979797;
        display: flex;
        align-items: center;
        padding-left: 14px;
        margin: 9px 0;
        flex-shrink: 0;
        box-sizing: border-box;
        color: #333333;

        &.active {
          background: #2262b1;
          border: 1px solid #2262b1;
          color: #ffffff;
        }

        i {
          width: 30px;
          height: 30px;
          border-radius: 10px;
        }

        span {
          font-size: 26px;
          padding-left: 6px;
        }
      }
    }
  }

  /* 检测报告 */
  .report {
    ul {
      li {
        width: 58px;
        height: 100%;
        border-left: 2px solid #ffffff;

        &:first-child {
          flex: 1;
          border-left: none;
        }

        &:last-child {
          width: 66px;
        }
      }
    }

    .header {
      height: 316px;
      background: #2262b1;
      border-radius: 10px;
      font-size: 32px;
      color: #ffffff;

      li {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        flex-wrap: wrap;

        i {
          width: 30px;
          height: 30px;
          border-radius: 10px;
          margin-bottom: 10px;
        }

        span {
          width: 30px;
          line-height: 36px;
        }
      }

      .item {
        font-size: 30px;
        line-height: 36px;
      }
    }

    .body {
      height: 80px;
      background: #f5f6f9;
      border-radius: 10px;
      margin-top: 10px;

      &:nth-child(2n) {
        background: #e0edff;
      }

      li {
        height: 100%;
        display: flex;
        font-size: 32px;
        color: #333333;
        align-items: center;

        img {
          width: 40px;
          height: 40px;
          object-fit: cover;
          margin: 0 10px 0 12px;
        }

        i {
          width: 30px;
          height: 30px;
          border-radius: 10px;
          margin: 0 auto;
        }

        .more {
          width: 40px;
          height: 40px;
          border-radius: 0;
          margin: 0 auto;
          background: url("../assets/more.png") no-repeat;
          background-size: 40px 40px;
        }
      }
    }
  }

  /* 检测要求和注意事项 */
  .demand {
    padding-bottom: 70px;

    p {
      font-size: 22px;
      /* 调小字号 */
      color: #959FB7;
      /* 设置为灰色 */
      line-height: 36px;
      /* 相应调整行高 */
      margin-top: 30px;
      /* 调整上边距 */
      text-align: justify;
      margin-left: 20px;

      &:first-child {
        margin-top: 0;
      }
    }
  }
}

.item-divider {
  width: 100%;
  height: 1px;
  border-top: 2px dashed #dfdfdf;
  /* 将实线背景改为虚线边框 */
  background-color: transparent;
  /* 移除背景色 */
  margin: 25px 0;
}

.full-health-info-button-container {
  padding: 20px 30px;
  margin: 20px 0;
}

.full-health-info-button-stack {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.full-health-info-button {
  width: 100%;
  height: 90px;
  background-color: #003cbf;
  color: #ffffff;
  border: none;
  border-radius: 45px;
  font-size: 27px;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background-color: #0056d3;
    transform: translateY(-2px);
  }

  &:active {
    transform: translateY(0);
  }
}

.full-health-info-button-row {
  display: flex;
  gap: 20px;
}

.full-health-info-button--primary {
  width: 100%;
}

.full-health-info-button--sub,
.full-health-info-button--pdf {
  flex: 1 1 0;
}

.full-health-info-button--sub {
  background-color: #1961FF;

  &:hover {
    background-color: #1961FF;
  }
}

.full-health-info-button--pdf {
  background-color: #FF5B4D;

  &:hover {
    background-color: #e5443a;
  }
}
</style>
